import type ApiCaller from '@campaign-manager/core/infra/repo/rmt-api/ApiCaller';
import type {
  ApiCallerOptions,
  Paginateable,
} from '@campaign-manager/core/infra/repo/rmt-api/ApiCaller';

export class Fetcher {
  constructor(private caller: ApiCaller) {}

  getKey(options: ApiCallerOptions) {
    return this.caller.getKey(options);
  }

  getKeyInfinite<Data extends Paginateable>(
    pageIndex: number,
    previousPageData: Data | null,
    options: ApiCallerOptions,
  ) {
    return this.caller.getKeyInfinite(pageIndex, previousPageData, options);
  }

  async call(options: ApiCallerOptions) {
    try {
      return await this.caller.call(options);
    } catch (e) {
      if (
        Object.prototype.hasOwnProperty.call(e, 'response') &&
        (e as { response?: { status?: number } }).response?.status === 498
      ) {
        window.location.href = '/';
      }

      if (process.env.NODE_ENV === 'production') {
        const Sentry = await import('@sentry/nextjs');
        Sentry.setExtra('error', e);
        Sentry.captureException(e);
      }

      throw e;
    }
  }
}
